/* global google */
import React from 'react'
import { withGoogleMap, GoogleMap, Marker, Polygon } from 'react-google-maps'
import withScriptjs from "react-google-maps/lib/withScriptjs"

export default withScriptjs(withGoogleMap(props => {

  const fitBounds = ref => {
    if (ref && props.paths && props.paths.length) {
      let bounds = new google.maps.LatLngBounds()
      props.paths.forEach(latlng => bounds.extend(latlng))
      ref.fitBounds(bounds)
    }
  }

  const polygonRef = React.createRef()
  const onExistingEdited = () => props.onPolygonEdited(polygonRef.current)

  return (
    <GoogleMap
      defaultZoom={15}
      center={props.center}
      ref={ref => fitBounds(ref)}
      onClick={e => { if (props.drawing) props.onMapClick(e.latLng) }} >
      {props.center.lat && props.center.lng && (
        <Marker position={{ lat: props.center.lat, lng: props.center.lng }}
          draggable={true}
          onDragEnd={(coord) => props.onMarkerDragEnd(coord)}
        />
      )}
      {!props.drawing && !props.radiusMode && props.paths && props.paths.length > 0 &&
        <Polygon
          defaultOptions={{ strokeColor: '#2f9d6d' }}
          ref={polygonRef} onMouseUp={onExistingEdited} editable={true} paths={props.paths} />}
      {props.drawing && props.drawnPath && props.drawnPath.length > 0 &&
        <Polygon
          options={{ strokeColor: '#2f9d6d', fillColor: '#2f9d6d', fillOpacity: 0.2 }}
          paths={props.drawnPath} />}
      {props.radiusMode && props.previewPath && props.previewPath.length > 0 &&
        <Polygon
          options={{ strokeColor: '#2f9d6d', fillColor: '#2f9d6d', fillOpacity: 0.2 }}
          paths={props.previewPath} />}
    </GoogleMap>
  )
}))
